<template>
  <div>
    <!--imagen objetivo estartégico-->
    <div class="row divHeaderObjetivos">
      <div>
        <q-img :src="imgObjetivoEstrategico" :alt="imgObjetivoEstrategico" />
      </div>
      <!--testo objetivo especifico-->
      <div class="col-11 divObjetivoEspecifico">
        Objetivo específico {{ objetivoEspecifico.name }}
      </div>
    </div>
    <!--indicador cualitativo-->
    <div class="divIndicador">
      <span class="titleIndicador">Indicador </span>
      <span class="nameIndicador">{{ nameIndicador }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { QImg } from 'quasar';
export default {
  components: {
    QImg
  },
  computed: {
    ...mapGetters({
      imgObjetivoEstrategico: 'NGUD/imgObjetivoEstrategico',
      objetivoEspecifico: 'NGUD/objetivoEspecifico',
      nameIndicador: 'NGUD/nameIndicador'
    })
  }
};
</script>
<style lang="scss" scoped>
  .divObjetivoEspecifico {
    padding-left: 15px;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0.26px;
  }
  .divHeaderObjetivos {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  .divIndicador {
    margin-bottom: 15px;
  }
  .divObjetivoEspecifico,
  .titleIndicador,
  .nameIndicador {
    font-family: DINPro;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    color: #4c4c4c;
  }

  .titleIndicador,
  .nameIndicador {
    font-size: 16px;
    letter-spacing: 0.23px;
  }
  .nameIndicador {
    font-weight: 500;
  }
  .titleIndicador {
    font-weight: bold;
  }
  .q-img{
    height: 40px;
    width: 40px;
  }
</style>
